import React from 'react';

import Link from '@atlaskit/link';

import { fg } from '@confluence/feature-gating';
import { CONTENT_HISTORY } from '@confluence/named-routes/entry-points/routes';

export const getPageHistoryLink = (attributes) => {
	const { spaceKey, contentId, contentSlug } = attributes;
	return (...chunks) =>
		fg('dst-a11y__replace-anchor-with-link__page-experienc') ? (
			<Link
				target="_blank"
				href={CONTENT_HISTORY.toUrl({
					spaceKey,
					contentId,
					contentSlug,
				})}
			>
				{chunks}
			</Link>
		) : (
			// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
			<a
				target="_blank"
				href={CONTENT_HISTORY.toUrl({
					spaceKey,
					contentId,
					contentSlug,
				})}
			>
				{chunks}
			</a>
		);
};
